import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    alert: false,
    alertMsg: '',
    alertCode: 'success'
  },
  mutations: {
    setErrorMessage(state, msg) {
      state.alert = true;
      state.alertMsg = msg;
      state.alertCode = 'error'
    },
    setInfoMessage(state, msg) {
      state.alert = true;
      state.alertMsg = msg;
      state.alertCode = 'info'
    },
    setSuccessMessage(state, msg) {
      state.alert = true;
      state.alertMsg = msg;
      state.alertCode = 'success'
    },
    disableAlert(state) {
      state.alert = false;
    }
  },
  actions: {

  }
})
